<template>
  <page>
    <sidebar slot="sidebar"/>
    <span slot="header">Topics</span>
    <span slot="breadcrumbs">
      <b-breadcrumb :items="breadcrumbs"/>
    </span>
    <form-wrapper>
      <b-form @submit="onSubmit">
        <b-form-group>
          <b-form-checkbox
            v-model="is_active"
            :disabled="saving"
            value="1"
            unchecked-value="0"
            @input="setActive">
            Active
          </b-form-checkbox>
        </b-form-group>

        <b-form-group>
          <label for="name-input">Name</label>
          <b-form-input
            v-validate="'required'"
            id="name-input"
            :disabled="saving"
            :class="{ 'is-invalid' : errors.has('name') || apiErrors.name.length }"
            :value="fields.name === null ? topic.name : fields.name"
            class="form-control"
            type="text"
            name="name"
            @input="setName"/>
          <validation-errors :validation-errors="[errors.first('name')]"/>
          <validation-errors v-if="!errors.has('name')" :validation-errors="apiErrors.name"/>
        </b-form-group>

        <b-form-group>
          <label for="description-input">Description</label>
          <b-form-textarea
            v-validate="'required'"
            id="description-input"
            :disabled="saving"
            :class="{ 'is-invalid' : errors.has('description') || apiErrors.description.length }"
            :rows="3"
            :max-rows="6"
            :value="fields.description === null ? topic.description : fields.description"
            type="text"
            name="description"
            @input="setDescription"/>
          <validation-errors :validation-errors="[errors.first('description')]"/>
          <validation-errors v-if="!errors.has('description')" :validation-errors="apiErrors.description"/>
        </b-form-group>

        <b-form-group class="form-buttons">
          <b-button :disabled="saving" variant="secondary" @click="$router.push({name: 'admin-topics'})">
            Cancel
          </b-button>
          <b-button :disabled="disabled" type="submit" variant="primary">
            Confirm
            <span v-if="saving"><i class="fas fa-spinner fa-spin"></i></span>
          </b-button>
        </b-form-group>

        <form-success :success="success" class="form-alert">Topic Updated!</form-success>
      </b-form>
    </form-wrapper>
  </page>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import formSuccess from '../../../common/form/form-success'
import formWrapper from '../../../common/form/form-wrapper'
import page from '../../../templates/page'
import sidebar from '../../../sidebar'
import validationErrors from '../../../common/form/validation-errors'

export default {
  components: {
    formSuccess,
    formWrapper,
    sidebar,
    page,
    validationErrors
  },
  data () {
    return {
      breadcrumbs: [{
        text: 'Modules',
        to: {
          name: 'admin-modules',
          params: {
            organization: this.$route.params.organization
          }
        }
      },
      {
        text: 'Components',
        to: {
          name: 'admin-components',
          params: {
            organization: this.$route.params.organization,
            module: this.$route.params.module
          }
        }
      },
      {
        text: 'Topics',
        to: {
          name: 'admin-topics',
          params: {
            organization: this.$route.params.organization,
            module: this.$route.params.module,
            component: this.$route.params.component
          }
        }
      },
      {
        text: 'Edit',
        active: true
      }]
    }
  },
  computed: {
    ...mapState('topics', {
      topic: 'current'
    }),
    ...mapState('topics/forms/update', [
      'apiErrors',
      'fields',
      'success',
      'saving'
    ]),
    is_active: {
      get () {
        return this.topic.is_active
      },
      set (newValue) {}
    },
    disabled () {
      return this.errors.any() || this.saving
    }
  },
  watch: {
    success (newValue, oldValue) {
      if (newValue === true && oldValue === false) {
        this.resetFields()
      }
    }
  },
  created() {
    this.$store.commit('topics/forms/update/resetState')
  },
  methods: {
    ...mapActions({
      updateTopic: 'topics/update'
    }),
    onSubmit (event) {
      event.preventDefault()
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.updateTopic({
            topicID: this.topic.id
          })
        }
      })
    },
    setActive (event) {
      this.$store.commit('topics/forms/update/setField', {
        field: 'active',
        value: event
      })
    },
    setName (event) {
      this.$store.commit('topics/forms/update/setField', {
        field: 'name',
        value: event
      })
    },
    setDescription (event) {
      this.$store.commit('topics/forms/update/setField', {
        field: 'description',
        value: event
      })
    },
    resetFields (event) {
      this.errors.clear()
      this.$store.commit('topics/forms/update/resetFields')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/topics/edit.vue